import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../Utils/baseQueryWithReauth";

export interface FlowStage {
  id: number;
  label: string;
  order: number;
  color?: string;
  days: number;
  startDate?: string;
  endDate?: string;
}

export interface FlowTransition {
  fromStageId: number;
  toStageId: number;
  label: string;
  color?: string;
  days: number;
  startDate?: string;
  endDate?: string;
}

export interface FlowUIModel {
  stages: FlowStage[];
  transitions: FlowTransition[];
}

// Define a service using a base URL and expected endpoints
export const exploreFeatureRequestAPI = createApi({
  reducerPath: "exploreFeatureRequests",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getFeatureRequestFilters: builder.query({
      query: () => "featureRequest/getFeatureRequestFilterData"
    }),
    getFeatureRequestFlow: builder.query<FlowUIModel, { featureRequestId: string }>({
      query: ({ featureRequestId }) => ({
        url: `featureRequest/getFeatureRequestFlow?featureRequestId=${featureRequestId}`
      })
    }),
    getFeatureDetailsByFeatureId: builder.query<any, { featureRequestId: string }>({
      query: ({ featureRequestId }) => ({
        url: `featureRequest/getFeatureDetailsByFeatureId?featureRequestId=${featureRequestId}`
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// Auto-generated based on the defined endpoints
export const {
  useGetFeatureRequestFiltersQuery,
  useLazyGetFeatureRequestFlowQuery,
  useLazyGetFeatureDetailsByFeatureIdQuery
} = exploreFeatureRequestAPI;
